import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const EXPAND_DELAY_MS = 500;

const prefersReducedMotion = () => {
  if (!window.matchMedia) {
    return false;
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

const alignMiddleImageOnMobile = (carousel) => {
  const middleImage = carousel.querySelector('.text-collage__image');
  const imageWidth = middleImage.offsetWidth;

  carousel.classList.remove('text-collage__images--mobile-fix');
  carousel.scrollTo(imageWidth, 0);
};

const initTextCollageBlock = (root) => {
  const images = root.querySelector('.text-collage__images');

  if (!images || root.dataset.textCollageInit === '1') {
    return;
  }

  const smallMQ = window.matchMedia(`(width <= ${breakpoints.sm}px)`);

  if (smallMQ.matches) {
    alignMiddleImageOnMobile(images);
  } else {
    smallMQ.addEventListener('change', (event) => {
      if (event.matches) {
        alignMiddleImageOnMobile(images);
      }
    }, { once: true });
  }

  // eslint-disable-next-line no-param-reassign
  root.dataset.textCollageInit = '1';

  if (prefersReducedMotion()) {
    root.removeAttribute('data-pre-animation');

    return;
  }

  let expandTimerId = null;

  const clearExpandTimer = () => {
    if (expandTimerId !== null) {
      window.clearTimeout(expandTimerId);
      expandTimerId = null;
    }
  };

  const scheduleExpand = () => {
    if (!root.hasAttribute('data-pre-animation')) {
      return;
    }

    clearExpandTimer();
    expandTimerId = window.setTimeout(() => {
      root.removeAttribute('data-pre-animation');
      expandTimerId = null;
      // eslint-disable-next-line no-use-before-define
      observer.disconnect();
    }, EXPAND_DELAY_MS);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          scheduleExpand();
        } else {
          clearExpandTimer();
        }
      });
    },
    {
      root: null,
      threshold: 0.2,
      rootMargin: '0px 0px -8% 0px',
    },
  );

  observer.observe(images);
};

const initTextCollage = () => {
  document.querySelectorAll('.text-collage').forEach((root) => {
    initTextCollageBlock(root);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/text-collage', () => {
      initTextCollage();
    });
  }

  initTextCollage();
});
